
// import router from "../router/index";
// import store from "../store";
import BaseApi from "./BaseApi";

export default class ReferenceService extends BaseApi {


    constructor(){
        super();
    }


    async list(business)
    {
        return this.http.get(`${this.baseUrl}/business/${business}/references`)
        .catch(this.handleErrorResponse);
    }

    async get(business, slug)
    {
        return this.http.get(`${this.baseUrl}/business/${business}/references/${slug}`)
        .catch(this.handleErrorResponse);
    }

    /**
     * GET
     * Get references for selectors
     * @param {string} business business slug
     */
    async getSelectReferences(business)
    {
        return this.http.get(`${this.baseUrl}/business/${business}/catalogs/references`)
        .catch(this.handleErrorResponse);
    }



    async store(business, data)
    {
        return this.http.post(`${this.baseUrl}/business/${business}/references`, data)
        .catch(this.handleErrorResponse);
    }

    async update(business, slug, data)
    {
        return this.http.put(`${this.baseUrl}/business/${business}/references/${slug}`,data)
        .catch(this.handleErrorResponse);
    }



    async delete(business, slug)
    {
        return this.http.delete(`${this.baseUrl}/business/${business}/references/${slug}`)
        .catch(this.handleErrorResponse);
    }


}